module.exports = __webpack_public_path__ + "static/img/bracelets-number.742953b4.png";